import Permissions from '../mixins/Permissions';
let right = Permissions.methods;

export default function menu_permission(to, from, next) {
  // Guest admin shell (login only): do not bounce /admin → /admin/denied
  const perms = typeof window !== 'undefined' ? window.Permissions : null;
  if ((!perms || !perms.length) && to.path && to.path.startsWith('/admin')) {
    return next();
  }

  if (to.meta.permission && !right.$can(to.meta.permission)) {
    next({ name: 'permission_denied', params: { from: from.name } });
    return false;
  }
  return next();
}
